import { useStation } from "viewer/store/station";
import { useMemo } from "react";

const sortCamerasByOrder = (cameras: StoreCameraDevice[], order: string[]): StoreCameraDevice[] => {
  if (order.length === 0) return cameras;
  return [...cameras].sort((a, b) => {
    const aIndex = order.indexOf(a.jid);
    const bIndex = order.indexOf(b.jid);
    if (aIndex === -1 && bIndex === -1) return 0;
    if (aIndex === -1) return 1;
    if (bIndex === -1) return -1;
    return aIndex - bIndex;
  });
};

export default function useCameraSort(cameras: StoreCameraDevice[]) {
  const cameraOrder = useStation((s) => s.cameraOrder);

  return useMemo(() => sortCamerasByOrder(cameras, cameraOrder), [cameras, cameraOrder]);
}
